/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Event_Ad_Auto_Rate_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Auto rate failed: {message}" |
*
* @param {Event_Ad_Auto_Rate_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_failed_toast = /** @type {((inputs: Event_Ad_Auto_Rate_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du taux automatique : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Automatische Bewertung fehlgeschlagen: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tasso automatico non riuscito: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Автоматическая оценка не удалась: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la tasa automática: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`自动评分失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`自動評価に失敗しました: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्वचालित दर निर्धारण विफल: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A taxa automática falhou: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Auto rate failed: ${i?.message}`)
});